







































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "ConfirmationModal",
  components: {
    AgroIcons,
  },
})
export default class ConfirmationModal extends Vue {
  @Prop({ type: String, default: "" }) private title!: string;
  @Prop({ type: String, default: "" }) private text!: string;
  @Prop({ type: String, default: "warning" }) private type!: string;
  @Prop({ type: String, default: "" }) private btnPrimaryLabel!: string;
  @Prop({ type: String, default: "" }) private btnSecondaryLabel!: string;
  @Prop({ type: Boolean, default: false}) private readonly isVisible!: boolean;

  private get isWarning() {
    return this.type === "warning";
  }

  private confirmAction() {
    this.emitConfirmAction();
  }

  private cancelAction() {
    this.emitCancelAction();
  }

  @Emit("onconfirm")
  private emitConfirmAction() {}

  @Emit("oncancel")
  private emitCancelAction() {}
}
